import { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { bindActionCreators } from 'redux';

import SourceSettings from './SourceSettings';
import DropdownItem from './DropdownItem';
import FiltersMobileModal from '../FiltersMobileModal';
import FilterButtonInfo from '../StoryFiltersButton/FilterButtonInfo';
import PlayVideoComponent from '../../PlayVideoComponent';

import StorageSvc from '../../../services/StorageSvc';

import { GOLD } from '../../../data/permissions';
import { majorContentFilter, premiumContentFilter } from '../../../data/filters/storyFilters';

import withComponentName from '../../../decorators/withComponentName';

import * as storyFiltersActions from '../../../actions/storyFilters.action';
import * as storyActions from '../../../actions/stories.actions';
import * as watchlistActions from '../../../actions/watchlistActions';
import * as searchActions from '../../../actions/searchActions';

import Styles from '../story-filters-styles.module.scss';

const cx = classNames.bind(Styles);

const STORAGE_KEY = 'SourceFilter';

export class SourceFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: {
        selectAll: true,
        selectAllSaved: false,
        open: false,
        selected: [],
        selectedNames: [],
        options: [],
        extraOptions: [],
        extraOptionsSaved: [],
        premiumContentFilter: [],
        majorContentFilter: [],
      },
      openFilterModal: false,
    };
    autoBind(this);
    this.majorContentRestored = false;
  }

  componentDidMount() {
    const presisted = StorageSvc.getItem(STORAGE_KEY);

    const {
      storyFilters, stateValue, initialStateValue,
    } = this.props;

    if (presisted !== null && !storyFilters.categories && stateValue !== initialStateValue) {
      const rehydrate = JSON.parse(presisted);
      this.setState({
        dropdown: {
          ...rehydrate.dropdown,
          ...premiumContentFilter,
          majorContentFilter: rehydrate.dropdown?.majorContentFilter ?? [
            {
              ...majorContentFilter,
              select: false,
            },
          ],
        },
      });
    } else {
      this.setValuesFromPreferences(); // load saved preferences choices into dropdown
    }
  }

  componentDidUpdate(prevProps) {
    const {
      values,
      storyFilters,
      token,
      stateValue,
      premiumContentOnly,
    } = this.props;
    const { dropdown } = this.state;

    // only fire this when categories changed from another component
    if (
      token
      && storyFilters.categories.length !== prevProps.storyFilters.categories.length
    ) {
      // for registered user
      this.setValuesFromPreferences();
    } else if (stateValue !== prevProps.stateValue && !dropdown.open) {
      // for guest user
      this.setValues(
        values,
      );
    } else if (token && premiumContentOnly !== prevProps.premiumContentOnly) {
      this.setState({
        dropdown: {
          ...dropdown,
          premiumContentFilter: [
            {
              ...premiumContentFilter,
              select: premiumContentOnly,
            },
          ],
        },
      });
    }
  }

  componentWillUnmount() {
    const { token } = this.props;
    if (!token) this.saveState();
  }

  handleCloseModal() {
    this.setState({ openFilterModal: false });
  }

  setValues(values) {
    const {
      extraAction,
      premiumContentOnly, extraValues,
    } = this.props;

    const selected = [];
    const selectedNames = [];

    values.forEach((item) => {
      if (item.select) {
        selected.push(item);
        selectedNames.push(item.name);
      }
      item.sub.forEach((subItem) => {
        if (subItem.select) {
          selectedNames.push(subItem.name);
        }
      });
    });

    const extra = JSON.parse(StorageSvc.getItem('state')).storyFilters.required_source;

    const ShowMajorSourcesValue = JSON.parse(StorageSvc.getItem('ShowMajorSources'))?.status;
    this.setState(({ dropdown }) => ({
      dropdown: {
        ...dropdown,
        selectAll: values.length === selected.length,
        options: values,
        extraOptions: [
          {
            ...extraValues[0],
            select: extra.registrationRequired,
          },
          {
            ...extraValues[1],
            select: extra.paywall,
          },
        ],
        extraValues,
        selected,
        selectedNames,
        premiumContentFilter: [
          {
            ...premiumContentFilter,
            select: premiumContentOnly,
          },
        ],
        majorContentFilter: [
          {
            ...majorContentFilter,
            select: ShowMajorSourcesValue,
          },
        ],
      },
    }), () => {
      const { dropdown: { extraOptions } } = this.state;
      extraAction({
        registrationRequired: extraOptions[0].select || false,
        paywall: extraOptions[1].select || false,
      });
    });
  }

  getSelectedNames(selected) {
    const selectedNames = [];

    selected.forEach((item) => {
      if (item.select) selectedNames.push(item.name);
    });

    return selectedNames;
  }

  setValuesFromPreferences() {
    const {
      values,
      storyFilters,
      premiumContentOnly,
    } = this.props;
    const { dropdown } = this.state;

    const selectedCategories = storyFilters.categories;
    for (const item of values) {
      let subItemSelectedLength = 0;

      for (const subItem of item.sub) {
        if (selectedCategories.includes(subItem.value)) {
          subItem.select = true;
          subItemSelectedLength += 1;
        } else {
          subItem.select = false;
        }
      }
      item.select = selectedCategories.includes(item.value)
        || (subItemSelectedLength === item.sub.length && subItemSelectedLength > 0);
    }
    this.setState({
      dropdown: {
        ...dropdown,
        premiumContentFilter: [
          {
            ...premiumContentFilter,
            select: premiumContentOnly,
          },
        ],
        ...((!dropdown.majorContentFilter || !this.majorContentRestored) && {
          majorContentFilter: [
            {
              ...majorContentFilter,
              select: selectedCategories.includes('mp') && !selectedCategories.includes('op'),
            },
          ],
        }),
        selectAll: selectedCategories.length === 3,
      },
    }, () => {
      this.setValues(
        values,
      );
    });
    this.majorContentRestored = true;
  }

  setValueSelected(selectedItem, childItem) {
    const { dropdown } = this.state;

    let newSelectedItem;

    if (childItem) {
      const newChildItem = { ...childItem };
      newChildItem.select = !childItem.select;

      const newSub = [...selectedItem.sub];
      newSub[newSub.indexOf(childItem)] = newChildItem;

      newSelectedItem = {
        ...selectedItem,
        select: newSub.reduce((sum, next) => sum && next.select, true),
        sub: newSub,
      };
    } else {
      newSelectedItem = this.selectItem(selectedItem);
    }

    const newOptions = dropdown.options;
    newOptions[newOptions.indexOf(selectedItem)] = newSelectedItem;

    const newSelected = [];
    newOptions.forEach((item) => { if (item.select) newSelected.push(item); });

    this.setState({
      dropdown: {
        ...dropdown,
        selectAll: newOptions.length === newSelected.length,
        options: newOptions,
        selected: newSelected,
        selectedNames: this.getSelectedNames(newOptions),
      },
    }, this.sendNewStateToAction);
  }

  saveToglePremiumContentFilterChanges(isSelect) {
    const {
      filterByPremiumContent, freezeStories, token, piwikEnabled,
    } = this.props;
    freezeStories(false);
    filterByPremiumContent(isSelect, token);

    if (piwikEnabled) {
      _paq.push(['trackEvent', 'Filters', 'Premium content toggle']);
    }
  }

  togglePremiumContentFilter(item) {
    const {
      hasGoldAccess,
    } = this.props;

    if (hasGoldAccess) {
      this.setState(({ dropdown }) => ({
        dropdown: {
          ...dropdown,
          premiumContentFilter: [
            {
              ...item,
              select: !item.select,
            },
          ],
        },
      }), () => {
        this.saveToglePremiumContentFilterChanges(!item.select);
      });
    }
  }

  toggleMajorContentFilter(item) {
    this.setState(({ dropdown }) => ({
      dropdown: {
        ...dropdown,
        majorContentFilter: [
          {
            ...item,
            select: !item.select,
          },
        ],
      },
    }), this.sendNewStateToAction);
  }

  toggleDropdown(status, event, source) {
    const { freezeStories, width } = this.props;
    const { dropdown } = this.state;

    if (
      status === false
      && source.source === 'select'
    ) {
      return;
    }

    if (width <= 1024) return this.openFilterModal();

    this.setState({
      dropdown: {
        ...dropdown,
        open: status,
      },
    }, () => {
      freezeStories(status);
    });
  }

  selectItem(item, forceStatus) {
    const status = typeof forceStatus === 'boolean' ? forceStatus : !item.select;

    return {
      ...item,
      select: status,
      sub: item.sub.map((subItem) => ({ ...subItem, select: status })),
    };
  }

  selectAll() {
    const { dropdown } = this.state;

    const status = !dropdown.selectAll;
    const newOptions = dropdown.options.map((item) => (
      this.selectItem(
        item,
        status,
      )
    ));

    this.setState({
      dropdown: {
        ...dropdown,
        selectAll: status,
        selectAllSaved: true,
        options: newOptions,
        selected: status ? newOptions.filter((item) => item.select) : [],
        selectedNames: status ? this.getSelectedNames(newOptions) : [],
      },
    }, () => {
      this.sendNewStateToAction();
      setTimeout(() => {
        this.setState((state) => ({
          dropdown: {
            ...state.dropdown,
            selectAllSaved: false,
          },
        }));
      }, 2000);
    });
  }

  extraSetValueSelected(selectedItem) {
    const { dropdown } = this.state;
    const { extraAction, token } = this.props;

    const newSelectedItem = this.selectItem(selectedItem);
    const newExtraOptions = dropdown.extraOptions;
    newExtraOptions[newExtraOptions.indexOf(selectedItem)] = newSelectedItem;

    this.setState({
      dropdown: {
        ...dropdown,
        extraOptions: newExtraOptions,
        extraOptionsSaved: [...dropdown.extraOptionsSaved, selectedItem.name],
      },
    }, () => {
      extraAction({
        registrationRequired: newExtraOptions[0].select,
        paywall: newExtraOptions[1].select,
      });

      if (!token) {
        this.saveState();
      }

      setTimeout(() => {
        this.setState((state) => ({
          dropdown: {
            ...state.dropdown,
            extraOptionsSaved: state.dropdown.extraOptionsSaved.filter((item) => (
              item !== selectedItem.name
            )),
          },
        }));
      }, 2000);
    });
  }

  sendNewStateToAction() {
    const {
      freezeStories, action,
      piwikEnabled, token,
    } = this.props;
    const { dropdown } = this.state;

    freezeStories(false);

    const actionPayload = [];
    const selectedItemsNames = [];
    const removedSources = [];

    dropdown.options.forEach((item) => {
      // if filter has children
      if (item.sub.length) {
        // loop through child and get selected
        item.sub.forEach((sub) => {
          if (sub.select) {
            actionPayload.push(...sub.value.split(','));
            selectedItemsNames.push(sub.name);
          } else if (!sub.select) {
            removedSources.push(sub.name);
          }
        });
      } else if (item.select) {
        actionPayload.push(...item.value.split(','));
        selectedItemsNames.push(item.name);
      } else if (!item.select) {
        removedSources.push(item.name);
      }
    });

    if (!dropdown.majorContentFilter[0]?.select && actionPayload.includes('mp')) {
      actionPayload.push('op');
    }

    // pass selected sources to piwik
    if (piwikEnabled) {
      _paq.push(['trackEvent', 'Filters', 'Add Story sources', `Selected: ${selectedItemsNames}, removde: ${removedSources}`]);
    }

    // pass value to action
    action([...new Set(actionPayload)].toString(), token);

    // save Major Content Filter
    StorageSvc.setItem('ShowMajorSources', JSON.stringify({ status: dropdown.majorContentFilter[0]?.select }));

    // save to localstorage for guest user
    if (!token) this.saveState();
  }

  saveState() {
    const { dropdown } = this.state;

    StorageSvc.setItem(
      STORAGE_KEY,
      JSON.stringify({ dropdown: { ...dropdown, open: false } }),
    );
  }

  reset(values, extraValues) {
    const { premiumContentOnly, storyFilters } = this.props;
    const selectedCategories = storyFilters.categories;

    this.setState({
      dropdown: {
        selectAll: true,
        open: false,
        selected: [],
        selectedNames: [],
        options: [],
        extraOptions: [],
        extraOptionsSaved: [],
        premiumContentFilter: [
          {
            ...premiumContentFilter,
            select: premiumContentOnly,
          },
        ],
        majorContentFilter: [
          {
            ...majorContentFilter,
            select: selectedCategories?.includes('mp') && !selectedCategories?.includes('op'),
          },
        ],
      },
    }, () => {
      this.setValues(
        values,
        extraValues,
      );
    });
  }

  resetExtraValues(extraValues) {
    const { dropdown } = this.state;
    const extra = JSON.parse(StorageSvc.getItem('state')).storyFilters.required_source;
    this.setState({
      dropdown: {
        ...dropdown,
        extraOptions: [
          {
            ...extraValues[0],
            select: extra.registrationRequired,
          },
          {
            ...extraValues[1],
            select: extra.paywall,
          },
        ],
      },
    });
  }

  resetAllExtraValues(extraValues) {
    const { dropdown } = this.state;
    this.setState({
      dropdown: {
        ...dropdown,
        extraOptions: [
          {
            ...extraValues[0],
            select: true,
          },
          {
            ...extraValues[1],
            select: true,
          },
        ],
      },
    });
  }

  resetMajorContentFilter() {
    const { dropdown } = this.state;
    this.setState({
      dropdown: {
        ...dropdown,
        majorContentFilter: [
          {
            ...majorContentFilter,
            select: false,
          },
        ],
      },
    }, () => {
      const { token } = this.props;
      if (!token) {
        this.saveState();
      }
    });
  }

  openFilterModal() {
    const { openFilterModal } = this.state;

    this.setState({ openFilterModal: !openFilterModal });
  }

  render() {
    const {
      rbi,
      dropdownTitle,
      user,
      width,
      piwikEnabled,
      sourcesEnabled,
      hasBigScreenDesign,
      isDisabled,
      token,
    } = this.props;
    const { dropdown, openFilterModal } = this.state;

    const sourceFilterBtnText = dropdown.selectAll
      ? 'All Sources'
      : dropdown.selectedNames.join(', ') || 'Select source...';

    return (
      <div id={cx('source-dropdown')} className={cx({ big_screen: hasBigScreenDesign })}>
        <Dropdown
          bsPrefix={cx('story-filters_btn', { rbi, disabled: isDisabled })}
          show={dropdown.open}
          onToggle={(status, event, source) => this.toggleDropdown(status, event, source)}
          alignRight={false}
        >
          <Dropdown.Toggle
            id={cx('source-dropdown-button')}
            variant="default"
          >
            <FilterButtonInfo
              dropdownTitle={dropdownTitle}
              openFilter={dropdown.open}
              width={width}
              rbi={rbi}
              selectedValue={sourceFilterBtnText}
              buttonErr={!dropdown.selectAll && dropdown.selectedNames.length === 0}
            />
          </Dropdown.Toggle>

          {width >= 1025 ? (
            <Dropdown.Menu
              show={dropdown.open}
              id={cx('source-dropdown-menu')}
              rootCloseEvent="click"
              flip={false}
            >
              <FilterInner
                dropdown={dropdown}
                dropdownTitle={dropdownTitle}
                toggleDropdown={this.toggleDropdown}
                selectAll={this.selectAll}
                setValueSelected={this.setValueSelected}
                width={width}
                togglePremiumContentFilter={this.togglePremiumContentFilter}
                toggleMajorContentFilter={this.toggleMajorContentFilter}
                piwikEnabled={piwikEnabled}
                user={user}
                extraSetValueSelected={this.extraSetValueSelected}
                sourcesEnabled={sourcesEnabled}
                token={token}
              />
            </Dropdown.Menu>
          ) : (
            <FiltersMobileModal
              openFilter={openFilterModal}
              handleCloseModal={this.handleCloseModal}
              showCloseIcon
              classname={cx({ disabledMessage: isDisabled })}
            >
              {isDisabled ? (
                <div className={cx('modalContainer')}>
                  <div className={cx('modalContent')}>
                    This filter is disabled for
                    {' '}
                    current page
                  </div>
                  <button
                    type="button"
                    className={cx('modalBtn')}
                    onClick={this.handleCloseModal}
                  >
                    OK
                  </button>
                </div>
              ) : (
                <FilterInner
                  dropdown={dropdown}
                  dropdownTitle={dropdownTitle}
                  toggleDropdown={this.toggleDropdown}
                  selectAll={this.selectAll}
                  setValueSelected={this.setValueSelected}
                  width={width}
                  togglePremiumContentFilter={this.togglePremiumContentFilter}
                  toggleMajorContentFilter={this.toggleMajorContentFilter}
                  piwikEnabled={piwikEnabled}
                  user={user}
                  extraSetValueSelected={this.extraSetValueSelected}
                  sourcesEnabled={sourcesEnabled}
                  token={token}
                />
              )}
            </FiltersMobileModal>
          )}
          {isDisabled && (
            <div className={cx('sourceFilter__tooltip')}>
              This filter is disabled for
              <br />
              current page
            </div>
          )}
        </Dropdown>
      </div>
    );
  }
}

const FilterInner = ({
  dropdown, dropdownTitle, selectAll, setValueSelected, width,
  togglePremiumContentFilter, piwikEnabled, user,
  extraSetValueSelected, sourcesEnabled, toggleMajorContentFilter, token,
}) => (
  <div className={`${cx('dropdown-items-wrapper')} source-dropdown-items-wrapper`}>
    <span className={`${cx('source_title', 'dropdown_title')}`}>
      {dropdownTitle}
      :
      <PlayVideoComponent
        videoLink="https://cityfalcon.wistia.com/medias/nq8g9ra0th"
        videoLinkMobile="https://cityfalcon.wistia.com/medias/ktxo5yh7gp"
        additionalStyles={cx('content_play_video')}
        tooltipAdditionalContentStyle={cx('content_play_video_tooltip')}
      />
    </span>
    <Dropdown.Item
      active={dropdown.selectAll}
      onClick={() => selectAll()}
      bsPrefix={cx('parent_checkbox', { active: dropdown.selectAll })}
    >
      <span className={cx('checkbox_box')}>
        {dropdown.selectAll && (
          <FontAwesomeIcon icon={faCheck} />
        )}
      </span>
      <span className={cx('dropdown__checkbox_title', 'main-title')}>
        Select / Unselect All
      </span>
    </Dropdown.Item>

    {dropdown.options.map((item, index) => (
      <DropdownItem
        key={item.name}
        item={item}
        index={index}
        setValueSelected={setValueSelected}
        width={width}
        lastChild={item.name === 'Research'}
      />
    ))}

    {dropdown.majorContentFilter.map((item, index) => (
      <DropdownItem
        key={item.id}
        item={item}
        index={index}
        setValueSelected={toggleMajorContentFilter}
        majorContentFilter
        width={width}
      />
    ))}

    {dropdown.premiumContentFilter.map((item, index) => (
      <DropdownItem
        key={item.id}
        item={item}
        index={index}
        setValueSelected={togglePremiumContentFilter}
        premiumContentFilter
        token={token}
        width={width}
      />
    ))}
    <SourceSettings
      user={user}
      width={width}
      piwikEnabled={piwikEnabled}
      extraOptions={dropdown.extraOptions}
      extraOptionsSaved={dropdown.extraOptionsSaved}
      extraSetValueSelected={extraSetValueSelected}
      sourcesEnabled={sourcesEnabled}
    />
  </div>
);
function mapToStateProps({ subscriptions, userPreferencesReducer, storyFilters }) {
  const { permissions, permissionsInitialized } = subscriptions;
  const { access_levels: accessLevels } = permissions;

  return {
    permissionsInitialized,
    premiumContentOnly: userPreferencesReducer.preferences.premium_content_only,
    storyFilters,
    hasGoldAccess: accessLevels.includes(GOLD),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...storyFiltersActions,
      ...storyActions,
      ...watchlistActions,
      ...searchActions,
    }, dispatch),
  };
}

export default connect(
  mapToStateProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(withComponentName(SourceFilter));
